<div class="box bg-gradient">
  <div
    nz-row
    class="box card-login-wrapper"
  >
    <app-card-standalone [title]="'PAGE.INVITE.TITLE' | translate">
      <ng-container>
        <form
          nz-form
          [formGroup]="inviteForm"
          class="auth-form"
          (ngSubmit)="submitForm()"
        >
          <nz-form-item>
            <nz-form-control [nzErrorTip]="emailErrorTpl">
              <nz-input-group [nzPrefix]="emailPrefixTemplate">
                <input
                  type="text"
                  nz-input
                  formControlName="email"
                  [placeholder]="'FORM.LABEL.EMAIL' | translate"
                />
              </nz-input-group>
              <ng-template #emailPrefixTemplate>
                <i class="fal fa-envelope"></i>
              </ng-template>
              <ng-template #emailErrorTpl let-control>
                <ng-container *ngIf="control.hasError('email')">
                  {{ "FORM.ERR.VALID_EMAIL" | translate }}
                </ng-container>
                <ng-container *ngIf="control.hasError('required')"
                  >{{ "FORM.ERR.REQUIRED_EMAIL" | translate }}
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="firstnameErrorTpl">
              <nz-input-group>
                <input
                  type="text"
                  nz-input
                  formControlName="firstname"
                  [placeholder]="'FORM.LABEL.FIRST_NAME' | translate"
                />
              </nz-input-group>
              <ng-template #firstnameErrorTpl let-control>
                <ng-container *ngIf="control.hasError('maxlength')">
                  {{ "FORM.ERR.MAX_CHARS" | translate: { value: 160 } }}
                </ng-container>
                <ng-container *ngIf="control.hasError('required')">
                  {{ "FORM.ERR.REQUIRED_FIRST_NAME" | translate }}
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="lastnameErrorTpl">
              <nz-input-group>
                <input
                  type="text"
                  nz-input
                  formControlName="lastname"
                  [placeholder]="'FORM.LABEL.LAST_NAME' | translate"
                />
              </nz-input-group>
              <ng-template #lastnameErrorTpl let-control>
                <ng-container *ngIf="control.hasError('maxlength')">
                  {{ "FORM.ERR.MAX_CHARS" | translate: { value: 160 } }}
                </ng-container>
                <ng-container *ngIf="control.hasError('required')">
                  {{ "FORM.ERR.REQUIRED_LAST_NAME" | translate }}
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control [nzErrorTip]="passwordErrorTpl">
              <nz-input-group
                [nzPrefix]="lockPrefixTemplate"
                [nzSuffix]="eyeSuffixTemplate"
              >
                <input
                  [type]="passwordVisible ? 'text' : 'password'"
                  nz-input
                  formControlName="password"
                  [placeholder]="'FORM.LABEL.PASSWORD' | translate"
                />
              </nz-input-group>
              <ng-template #eyeSuffixTemplate>
                <i
                  class="cursor-pointer fal"
                  [ngClass]="passwordVisible ? 'fa-eye-slash' : 'fa-eye'"
                  (click)="passwordVisible = !passwordVisible"
                ></i>
              </ng-template>
              <ng-template #lockPrefixTemplate>
                <i class="fal fa-lock"></i>
              </ng-template>
              <ng-template #passwordErrorTpl let-control>
                <ng-container *ngIf="control.hasError('maxlength')">
                  {{ "FORM.ERR.MAX_CHARS" | translate: { value: 40 } }}
                </ng-container>
                <ng-container *ngIf="control.hasError('minlength')">
                  {{ "FORM.ERR.MIN_CHARS" | translate: { value: 8 } }}
                </ng-container>
                <ng-container *ngIf="control.hasError('required')">
                  {{ "FORM.ERR.REQUIRED_PASS" | translate }}
                </ng-container>
                <ng-container
                  *ngIf="
                    !control.hasError('required') &&
                    !control.hasError('minlength') &&
                    !control.hasError('maxlength') &&
                    control.hasError('pattern')
                  "
                >
                  {{ "PAGE.AUTH.PASSWORD_REQUIREMENTS.ERROR" | translate }}
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-control [nzErrorTip]="confirmPasswordErrorTpl">
              <nz-input-group
                [nzPrefix]="lockPrefixTemplate"
                [nzSuffix]="eyeSuffix2Template"
              >
                <input
                  formControlName="confirmPassword"
                  [type]="confirmPasswordVisible ? 'text' : 'password'"
                  nz-input
                  [placeholder]="'FORM.LABEL.CONFIRM_PASSWORD' | translate"
                />
              </nz-input-group>
              <ng-template #eyeSuffix2Template>
                <i
                  class="cursor-pointer fal"
                  [ngClass]="confirmPasswordVisible ? 'fa-eye-slash' : 'fa-eye'"
                  (click)="confirmPasswordVisible = !confirmPasswordVisible"
                ></i>
              </ng-template>
              <ng-template #lockPrefixTemplate>
                <i class="fal fa-lock"></i>
              </ng-template>
              <ng-template #confirmPasswordErrorTpl let-control>
                <ng-container *ngIf="control.hasError('equalTo')">
                  {{ "FORM.ERR.PASSWORDS_DO_NOT_MATCH" | translate }}
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-control>
              <button
                [nzLoading]="isSubmitting$ | async"
                [disabled]="!inviteForm.valid"
                nz-button
                class="auth-form-button"
                [nzType]="'primary'"
              >
                {{ "PAGE.INVITE.TITLE" | translate }}
              </button>
            </nz-form-control>
          </nz-form-item>
        </form>
      </ng-container>
    </app-card-standalone>

    <div class="select-lang-wrapper">
      <app-select-language></app-select-language>
    </div>
    <app-password-requirements></app-password-requirements>
  </div>
</div>
